@import '../../theme/global';

snap-avatar {
  a {
    color: inherit;
    text-decoration: inherit;
  }

  p {
    margin: 0;
  }
  display: flex;
  font-family: $font-family;

  .notification-top {
    top: 0;
  }

  .notification-bottom {
    bottom: 0;
  }

  .notification-top-transform {
    transform: translateY(-50%) translateX(50%);
  }

  .notification-bottom-transform {
    transform: translateY(50%) translateX(50%);
  }

  .img-rounded-full {
    border-radius: 9999px;
    object-fit: cover;
  }

  .img-rounded-md {
    border-radius: 0.375rem;
  }

  .snap-avatar {
    display: inline-block;

    &--xs {
      height: 1.5rem;
      width: 1.5rem;

      & + .snap-avatar-notification {
        height: 0.375rem;
        width: 0.375rem;
      }
    }

    &--sm {
      height: 2rem;
      width: 2rem;

      & + .snap-avatar-notification {
        height: 0.5rem;
        width: 0.5rem;
      }
    }

    &--md {
      height: 2.5rem;
      width: 2.5rem;

      & + .snap-avatar-notification {
        height: 0.625rem;
        width: 0.625rem;
      }
    }

    &--lg {
      height: 3rem;
      width: 3rem;

      & + .snap-avatar-notification {
        height: 0.875rem;
        width: 0.875rem;
      }
    }

    &--xl {
      height: 3.5rem;
      width: 3.5rem;

      & + .snap-avatar-notification {
        height: 0.875rem;
        width: 0.875rem;
      }
    }

    &--xxl {
      height: 4rem;
      width: 4rem;

      & + .snap-avatar-notification {
        height: 1rem;
        width: 1rem;
      }
    }

    &--profile,
    &--profile-lg {
      box-shadow: 0 0 0 4px #fff;
    }

    &--profile {
      height: 6rem;
      width: 6rem;

      & + .snap-avatar-notification {
        height: 1.5rem;
        width: 1.5rem;
      }
    }

    &--profile-lg {
      height: 8rem;
      width: 8rem;

      & + .snap-avatar-notification {
        height: 2rem;
        width: 2rem;
      }
    }
  }

  .span-avatar-notification-wrapper {
    display: inline-block;
    position: relative;
  }

  .snap-avatar-notification {
    background-color: $green-400;
    border-radius: 9999px;
    box-shadow: $ring-2;
    display: block;
    position: absolute;
    right: 0;
  }

  .snap-avatar-initials {
    align-items: center;
    background-color: $gray-500;
    border-radius: 9999px;
    display: inline-flex;
    justify-content: center;

    &--xs {
      height: 1.5rem;
      width: 1.5rem;

      span {
        font-size: 0.75rem;
        line-height: 1rem;
      }
    }

    &--sm {
      height: 2rem;
      width: 2rem;

      span {
        font-size: 0.875rem;
        line-height: 1.25rem;
      }
    }

    &--md {
      height: 2.5rem;
      width: 2.5rem;
    }

    &--lg {
      height: 3rem;
      width: 3rem;

      span {
        font-size: 1.125rem;
        line-height: 1.75rem;
      }
    }

    &--xl {
      height: 3.5rem;
      width: 3.5rem;

      span {
        font-size: 1.25rem;
        line-height: 1.75rem;
      }
    }

    &--xxl {
      height: 4rem;
      width: 4rem;

      span {
        font-size: 1.5rem;
        line-height: 2rem;
      }
    }

    &--profile {
      height: 6rem;
      width: 6rem;

      span {
        font-size: 2.25rem;
        line-height: 2.5rem;
      }
    }

    &--profile-lg {
      height: 8rem;
      width: 8rem;

      span {
        font-size: 3rem;
        line-height: 1;
      }
    }

    span {
      color: $base-light;
      font-weight: 500;
      line-height: 1;
    }
  }

  .snap-avatar-placeholder-icon {
    background: $gray-100;
    border-radius: 9999px;
    display: inline-block;
    overflow: hidden;

    &--xs {
      height: 1.5rem;
      width: 1.5rem;
    }

    &--sm {
      height: 2rem;
      width: 2rem;
    }

    &--md {
      height: 2.5rem;
      width: 2.5rem;
    }

    &--lg {
      height: 3rem;
      width: 3rem;
    }

    &--xl {
      height: 3.5rem;
      width: 3.5rem;
    }

    &--xxl {
      height: 4rem;
      width: 4rem;
    }

    &--profile {
      height: 6rem;
      width: 6rem;
    }

    &--profile-lg {
      height: 8rem;
      width: 8rem;
    }

    svg {
      color: $gray-300;
      height: 100%;
      width: 100%;
    }
  }

  .snap-avatar-with-text {
    display: block;
    flex-shrink: 0;

    &:hover .text-top {
      color: $gray-900;
    }

    &:hover .text-bottom {
      color: $gray-700;
    }
  }

  .snap-avatar-with-text-wrapper {
    align-items: center;
    display: flex;

    .snap-avatar-placeholder-icon {
      display: flex;
    }
  }

  .snap-avatar-with-text-img {
    border-radius: 9999px;
    display: inline-block;
    height: 2.25rem;
    object-fit: cover;
    width: 2.25rem;
  }

  .snap-avatar-with-text-right-wrapper {
    margin-left: 0.75rem;

    .text-top {
      color: $gray-700;
      font-size: 0.875rem;
      font-weight: 500;
      line-height: 1.25rem;
    }

    .text-bottom {
      color: $gray-500;
      font-size: 0.75rem;
      font-weight: 500;
      line-height: 1rem;
    }
  }
}
